import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { userHasCap } from '../../helpers/Auth';
import { runAction } from '../../helpers/Integrations';

const FileDesignPickleIntegrationButton = ({ integrations, files }) => {
  const intl = useIntl();

  if (!userHasCap('integrations')) {
    return null;
  }

  if (files.find(f => f.deleted_at)) {
    return null;
  }

  const integration = integrations.find(i => (i.id === 'design-pickle'));
  if (!integration) {
    return null;
  }
  const action = integration.actions?.find(ia => (ia.id === 'create-request'));
  if (!action) {
    return null;
  }

  return (
    <>
      <Button
        id="integration-design-pickle-button"
        className="btn-integration btn-design-pickle"
        onClick={() => {
          runAction(action, files);
        }}
      >
        <img src="/images/integrations/dp-logo.png" alt="Design Pickle Request" />
        <span>
          {intl.formatMessage({ defaultMessage: 'Request' })}
        </span>
      </Button>
      <UncontrolledTooltip target="integration-design-pickle-button" fade={false}>
        {intl.formatMessage({ defaultMessage: 'Create request in Design Pickle' })}
      </UncontrolledTooltip>
    </>
  );
};

const mapStateToProps = state => ({
  integrations: state.Auth.profile?.integrations,
});

FileDesignPickleIntegrationButton.propTypes = {
  integrations: PropTypes.array,
  files: PropTypes.array.isRequired,
};

FileDesignPickleIntegrationButton.defaultProps = {
  integrations: [],
};

export default connect(mapStateToProps)(FileDesignPickleIntegrationButton);
